/** Dialog `onClose` — no-op while mutation in-flight (busy-buttons.mdc). */
export const blockDialogCloseWhenBusy = (
  busy: boolean,
  onClose: () => void,
): (() => void) | undefined => (busy ? undefined : onClose);

/** Guard manual close handlers (Cancel button, X icon). */
export const guardDialogCloseWhenBusy = (busy: boolean, onClose: () => void): (() => void) => {
  return () => {
    if (busy) return;
    onClose();
  };
};
